class FfMenu extends HTMLElement {
  constructor() {
    super();
    this.listTags = this.querySelectorAll(".ff-list-item");
    this.headerLink = this.querySelectorAll(".ff-header-link");
    this.subHeaderLink = this.querySelectorAll(".ff-submenu");
    this.weglot = document.querySelector(".ff-weglot-desk");
    if (window.innerWidth > 749) {
      this.caretArrow = this.weglot.parentElement.children[1].children[0];
    }
    this.template = this.dataset.template;
    this.addEvents();
    this.clickHeader();
    this.clickSubHeader();
  }

  addEvents() {
    this.stickyHeader = document.getElementById("sticky-header");
    const heightStickyHeader = this.stickyHeader.offsetHeight;

    this.listTags.forEach((element) => {
      element.addEventListener("mouseover", () => {
        this.mainDetailsToggle = element.querySelector("details");
        this.mainDetailsToggle &&
          this.mainDetailsToggle.setAttribute("open", "");
        this.mainDetailsToggle &&
          this.mainDetailsToggle
            .querySelector("summary")
            .setAttribute("aria-expanded", true);
        const ulListHeight =
          this.mainDetailsToggle && element.querySelector("ul").clientHeight;
        if (ulListHeight) {
          element.setAttribute("data-height", ulListHeight + 50);
          element.style.height = `${ulListHeight + 50}px`;
        }
      });
      this.stickyHeader.addEventListener("mouseover", () => {
        this.logo = document.getElementsByClassName("header__heading-logo");
        this.anchorListText = document.getElementsByClassName("anchor-list");
        this.liList = document.getElementsByClassName("right-list-item");
        this.searchBarIcons = document.getElementsByClassName("search-bar");
        this.myAccount = document.getElementById("my_account");

        if (window.pageYOffset === 0) {
          this.stickyHeader.classList.remove("bg-transparent");
          this.stickyHeader.classList.add("bg-color");
          if (this.template === "index") {
            !this.stickyHeader.firstElementChild.classList.contains("border-bottom") && this.stickyHeader.classList.add("border-bottom");
            this.stickyHeader.style.position = "fixed";
            this.logo[0].classList.remove("inverter");
            this.myAccount.classList.remove("color-alternative");
            this.caretArrow && this.caretArrow.classList.remove("color-alternative");
            for (const anchor of this.anchorListText) {
              anchor.classList.remove("color-alternative");
            }
            for (const li of this.liList) {
              li.classList.remove("color-alternative");
            }
            for (const icon of this.searchBarIcons) {
              icon.classList.remove("color-alternative");
              icon.children[0]?.classList.remove("color-alternative");
            }
          } else {
            this.stickyHeader.style.position = "fixed";
            this.mainContent = document.querySelector("main");
            this.mainContent.style.paddingTop = `${heightStickyHeader}px`;
          }
        } else {
          this.stickyHeader.classList.remove("bg-transparent");
          this.stickyHeader.classList.add("bg-color");
          if (this.template === "index") {
            this.stickyHeader.style.position = "fixed";
            this.logo[0].classList.remove("inverter");
            this.myAccount.classList.remove("color-alternative");
            for (const anchor of this.anchorListText) {
              anchor.classList.remove("color-alternative");
            }
            for (const li of this.liList) {
              li.classList.remove("color-alternative");
            }
            for (const icon of this.searchBarIcons) {
              icon.classList.remove("color-alternative");
            }
          }
        }
      });
      element.addEventListener("mouseleave", () => {
        this.mainDetailsToggle = element.querySelector("details");
        this.mainDetailsToggle &&
          this.mainDetailsToggle.removeAttribute("open", "");
        this.mainDetailsToggle &&
          this.mainDetailsToggle
            .querySelector("summary")
            .setAttribute("aria-expanded", false);
        element.style.height = "initial";
      });
      this.stickyHeader.addEventListener("mouseleave", () => {
        this.stickyHeader = document.getElementById("sticky-header");
        this.logo = document.getElementsByClassName("header__heading-logo");
        this.anchorListText = document.getElementsByClassName("anchor-list");
        this.liList = document.getElementsByClassName("right-list-item");
        this.searchBarIcons = document.getElementsByClassName("search-bar");
        this.myAccount = document.getElementById("my_account");

        if (window.pageYOffset === 0) {
          this.mainContent = document.querySelector("main");
          this.mainContent.style.paddingTop = `initial`;
          this.stickyHeader.classList.add("bg-transparent");
          if (this.template === "index") {
            this.stickyHeader.style.position = "fixed";
            this.stickyHeader.classList.remove("border-bottom");
            this.stickyHeader.classList.remove("bg-color");
            this.logo[0].classList.add("inverter");
            this.myAccount.classList.add("color-alternative");
            this.caretArrow && this.caretArrow.classList.add("color-alternative");
            for (const anchor of this.anchorListText) {
              anchor.classList.add("color-alternative");
            }
            for (const li of this.liList) {
              li.classList.add("color-alternative");
            }
            for (const icon of this.searchBarIcons) {
              icon.classList.add("color-alternative");
              icon.children[0]?.classList.add("color-alternative");
            }
          } else {
            this.stickyHeader.style.position = "sticky";
          }
        }
      });
    });
  }

  clickHeader() {
    this.headerLink.forEach((element) => {
      element.addEventListener("click", () => {
        element.parentNode.removeAttribute("open");
        element.setAttribute("aria-expanded", true);
      });
    });
  }

  clickSubHeader() {
    this.subHeaderLink.forEach((element) => {
      const subHeaderOpen = element.nextElementSibling.clientHeight;
      element.addEventListener("click", () => {
        if (element.nextElementSibling.hasAttribute("closed")) {
          element.nextElementSibling.setAttribute("open", "");
          element.nextElementSibling.removeAttribute("closed");
          for (const tag of this.listTags) {
            if (tag.style.height !== "initial" && tag.style.height) {
              tag.style.height = `${
                parseInt(tag.style.height.split("p")[0]) + tag.dataset.height + 50
              }px`;
            }
          }
        } else {
          for (const tag of this.listTags) {
            tag.dataset.height && (tag.style.height = `${tag.dataset.height}px`);
          }
          element.nextElementSibling.setAttribute("closed", "");
          element.nextElementSibling.removeAttribute("open");
        }
      });
    });
  }
}
customElements.define("ff-menu", FfMenu);
